import { requestBuilder } from '../../http/RequestBuilder';
import type { IManualAccount, UpdateAccount } from '../types/ManualAccount';

const useUpdateManualAccount = requestBuilder.mutation<
    IManualAccount,
    UpdateAccount
>({
    endpoint: '/api/manual-accounts/update',
    method: 'PATCH',
});

export default useUpdateManualAccount;
